/**
 * TO-DO
 *
 * 1. Aplicando Single-responsibility principle de
 * los principios SOLID refactorizar la siguiente
 * aplicación
 *
 * 2. Implementar un custom hook para la carga
 * inicial de datos e implementar una paginación
 * Aqui se puede encontrar la documentación
 * sobre el API de pokemons implementado
 * https://pokeapi.co/docs/v2
 *
 * 3. Cada Nombre de Pokemon debe ser clickable
 * y mostrar la información del pokemon
 * (imagen, nombre, movimientos, tipos) en una página
 * nueva, implementar la lógica necesaria
 * para obtener dicha información obtenida del api
 * antes mencionado https://pokeapi.co/docs/v2
 *
 * 4. Cada uno de los movimientos del pokemon
 * deben ser clickable y debe llevar a una
 * página nueva donde se muestre la descripcion de los
 * campos effect y short_effect de effect_entries
 * power y acurracy
 *
 * Nota: para la navegación se usa react-router-dom
 * aquí se puede consultar el API https://v5.reactrouter.com/web/guides/quick-start
 *
 * 5. Darle una interfaz más agradable (A su gusto)
 * importante darle una migas (Breadcrumbs)
 * a la actual aplicación para lo cual se usa material UI
 * la version 4.x.x aqui se puede ver la
 * documentación https://v4.mui.com/
 *
 * 6. Implementar página 404 para cualquier página
 * inexistente
 *
 * 7. Implementar los test unitarios que sean
 * covenientes, para lo cual se usa JEST,
 * testing-library/react, testing-library/hooks,
 * axios-mock-adapter
 */

import { StrictMode } from "react";

import ReactDOM from "react-dom";

import App from "./App";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  rootElement
);
